import {createContext} from 'react'

const readerContext = createContext()

export default readerContext
